export const clientDetailsRoutes = [
  {
    path: ':id',
    name: 'client-details',
    component: () => import(/* webpackChunkName: "client-details" */ './ClientDetails.vue')
  }
];
